import React from 'react'
import Tips from '@/components/Tips/Tips'
import moment from 'moment'

import { connect } from 'react-redux'
import { tipsType } from '@/constants/tips-type'
import { settingConfigs } from '@/configurations'

class ImportantNotesDialog extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { language, lastLoginTime, data } = this.props
    const isPasswordExpired = data.passwordExpired === 'Y'
    return (
      <React.Fragment>
        <div style={{ width: '670px', padding: '30px 30px 0' }}>
          { isPasswordExpired && <Tips type={tipsType.error}>{language.important_notes_warning}</Tips> }
          <section>
            <p style={{ lineHeight: '20px' }}>{language.important_notes_content}</p>
            <p style={{ textAlign: 'center', padding: '40px', fontWeight: 'bold' }}>
              {language.important_notes_login_date}&nbsp;
              {lastLoginTime ? moment(lastLoginTime).format(settingConfigs.LONG_DATE) : '--/--/--- --:--:--'}
              <b>（HKT）</b>
            </p>
          </section>
        </div>
      </React.Fragment>
    )
  }
}

export default connect(state => ({
  language: state.app.language,
  lastLoginTime: state.auth.lastLoginTime
}))(ImportantNotesDialog)
